import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo } from "react";
import { analyticsEvents } from "@/lib/analytics-events";

interface TrackableListing {
  sqid: string;
  free: boolean;
  price_cents: number | null;
  price_currency: string | null;
}

// Fires `product_viewed` on mount and returns a `trackCheckout` callback for the
// buy action. Shared by the product and service show pages, which render the same
// view and carry an identical analytics contract.
export function useListingAnalytics(
  listing: TrackableListing,
  listingType: "product" | "service",
  sellerAccountId: number,
) {
  const posthog = usePostHog();
  const properties = useMemo(
    () => ({
      listing_id: listing.sqid,
      listing_type: listingType,
      is_free: listing.free,
      price_cents: listing.price_cents,
      currency: listing.price_currency,
      seller_account_id: sellerAccountId,
    }),
    [listing.sqid, listing.free, listing.price_cents, listing.price_currency, listingType, sellerAccountId],
  );

  useEffect(() => {
    posthog.capture(analyticsEvents.productViewed, properties);
  }, [posthog, properties]);

  return { trackCheckout: () => posthog.capture(analyticsEvents.checkoutStarted, properties) };
}
